<template>
  <li v-if="feature" class="row">
    <div v-if="featureLabel && feature" class="title">{{ featureLabel }}: {{ feature.Name }}</div>
    <div v-else class="title">{{ feature.Name }}</div>
    <div class="code">
      <small>{{ feature.ShortId }}</small>
    </div>
    <div v-if="showExcl" class="price price-excl">
      <template v-if="!showIncl && Number.parseFloat(feature.Price.Excl) === 0">
        Geen meerprijs
      </template>
      <template v-else-if="Number.parseFloat(feature.Price.Excl) !== 0">
        {{ i18n.n(feature.Price.Excl, 'currency') }}
      </template>
    </div>
    <div v-if="showIncl" class="price price-incl">{{ priceIncl }}</div>
  </li>
</template>

<script>
export default {
  props: {
    feature: {
      type: Object,
      default: null,
    },
    featureLabel: {
      type: String,
      default: '',
    },
    showIncl: {
      type: Boolean,
      default: true,
    },
    showExcl: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      i18n: window.VUE_CLI_EXPORTS.plugins.i18n,
    }
  },
  computed: {
    priceIncl() {
      return Number.parseFloat(this.feature.Price.Incl) !== 0
        ? this.i18n.n(this.feature.Price.Incl, 'currency')
        : 'Geen meerprijs'
    },
  },
}
</script>
